var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 8
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.763 7.694L.288 4a1.092 1.092 0 010-1.477.942.942 0 011.39 0l2.78 2.955L9.323.306a.942.942 0 011.39 0 1.092 1.092 0 010 1.477l-5.56 5.91a.95.95 0 01-.695.306.951.951 0 01-.695-.305z"
  })));
}
export default SvgCheck;